module.exports = __webpack_public_path__ + "static/images/hero.62e69e7d7b043e38be7f31ab97201cfc.jpg";